import { get, upload, put, post, del } from '@api/request';

export async function fetchImportExemptions(
  { appraisalNoticeService },
  authenticationToken,
  { page, pageSize },
) {
  const url = `${appraisalNoticeService}/import/exemptions?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createImportExemption(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/import/exemptions`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function fetchImportExemption(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/import/exemption/${importID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImportExemptionYearstoProcess(
  { appraisalNoticeService },
  authenticationToken,
  { importID },
) {
  const url = `${appraisalNoticeService}/import/exemption/${importID}/yearstoprocess`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createProcessExemption(
  { appraisalNoticeService },
  authenticationToken,
  { importID, payload },
) {
  const url = `${appraisalNoticeService}/import/exemption/${importID}/createexemptions`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchImportExemptionProperties(
  { appraisalNoticeService },
  authenticationToken,
  { importID, page, pageSize, criteria },
) {
  const url = `${appraisalNoticeService}/import/exemption/${importID}/properties?page=${page}&pageSize=${pageSize}&criteria=${criteria}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAvailableStateCodes(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/import/exemption/availablestatecodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchHSStateCodes(
  { appraisalNoticeService },
  authenticationToken,
) {
  const url = `${appraisalNoticeService}/import/exemption/hsstatecodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertHSStateCode(
  { appraisalNoticeService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalNoticeService}/import/exemption/hsstatecodes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteHSStateCode(
  { appraisalNoticeService },
  authenticationToken,
  { importStateID },
) {
  const url = `${appraisalNoticeService}/import/exemption/hsstatecode/${importStateID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
